import React, { Fragment } from 'react';
import Header from '../elements/Header';
import NextStep from '../elements/NextStep';
import PropTypes from 'prop-types';
import connect from "react-redux/es/connect/connect";

import { __ } from 'i18n-for-browser';

import BankSavingDropdown from "../elements/StepThree/BankSavingDropdown";
import gameStateInputFromActions from '../../actions/gameStateInput';
import DifficultyAwareComponent from "../DifficultyAwareComponent";
import { calculateBudgetPRO, calculateSavingsAndLoans, calculateBudgetBASIC } from "../../helpers/calculationsHelper";
import { getSavedGlobas, getSavingsInterest, getOverview, getUnreadGifts, setGiftsRead } from "../../helpers/bankHelper";
import { getContent } from "../../helpers/popupHelper";

/**
 * Import assets
 */
import LoanBank from "../../assets/img/icons/lenen_bank.svg";
import LoanBankLow from "../../assets/img/icons/lenen_bank_laag.svg";
import LoanLand from "../../assets/img/icons/lenen_land.svg";
import LoanToLand from "../../assets/img/icons/uitlenen_land.svg";
import BankIcon from "../../assets/img/icons/bank.png";
import Savings from "../../assets/img/icons/opnemen_spaargeld.svg";
import SavingsBank from "../../assets/img/icons/sparen_bank.svg";
import Gift from "../../assets/img/icons/schenken_land.svg";
import Pending from "../../assets/img/icons/pending.svg";
import Approved from "../../assets/img/icons/approved.svg";
import DebitCreditDialog from '../elements/DebitCreditDialog';
import PopupTitle from "../elements/PopupTitle";
import GoBackButton from "../elements/GoBackButton";
import Scrollbar from "react-scrollbars-custom";
import {simulateDebitCreditOutcome} from "../../helpers/feedbackHelpers";

// let cleared = 0;
const { updateMyState } = gameStateInputFromActions;

class Bank extends DifficultyAwareComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      showDropDown: 0,
      lenenVanLand: false,
      lenenAanLand: false,
      overview: [{
        items: [{},{},{},{}]
      }]
    };
    this.getConfirmedEntries = this.getConfirmedEntries.bind(this);
    this.renderCurRoundPayback = this.renderCurRoundPayback.bind(this);

    // Reset bank values on page load
    Object.keys(this.props.gameStateInput.myState.debitCredit).forEach((k) => {
      const debitCredit = this.props.gameStateInput.myState.debitCredit;
      console.log(debitCredit);
      if (typeof debitCredit[k] === 'object' && !debitCredit[k].confirmed) {
        debitCredit[k].amount = 0;
        debitCredit[k].interest = 0;
      }
      this.props.dispatch(updateMyState({ debitCredit }));
    });
  }

  componentWillReceiveProps(props) {
    /**
     * This block of code will make sure that whenever we cancel the last pending sparen / lenen item
     * and the overview section is open, the section gets closed again.
     *
     * Client bug description:
     * De bovenste 2 balken onder het ' Overzicht' zijn hoger dan de onderste 2 balken (dit is na het annuleren van leningen,
     * dus er staat nu niks in, maar er heeft wel info in gestaan. )
     */
    const overview = getOverview(props.gameStateInput, props.dispatch, this.state, this.props.bankNotificationsState);
    const stateOverview = this.state.overview;
    let change = false;
    for(let i = 0; i < overview[0].items.length; i += 1) {
      if (stateOverview[0].items[i].open && !overview[0].items[i].items.length) {
        change = true;
        stateOverview[0].items[i].open = false;
      }
    }
    if (change) {
      this.setState({ overview: stateOverview });
    }
    return props;
  }

  componentDidMount() {
  }

  toggleDropDown(id) {
    if (this.state.showDropDown === id) {
      this.setState({
        showDropDown: 0,
      });
    } else {
      this.setState({
        showDropDown: id,
      });
    }
  }

  toggleOpen(section, index, dispatch, item) {
    if (item.items.length === 0) return;

    const {overview} = this.state;
    const { gameStateInput } = this.props;
    if(item.keys) {
      const { debitCredit } = gameStateInput.myState;
      item.keys
        .filter(key => debitCredit[key])
        .forEach(key => debitCredit[key].unread = false);
      setGiftsRead(gameStateInput);
      dispatch(updateMyState({ debitCredit }))
    }
    overview[section].items[index].open = !overview[section].items[index].open;
    this.setState({overview});
  }

  printOverview = (gameStateInput, dispatch) => {
    let { currentRound, totalRounds}  = this.props.feedback;
    const isHistory = (currentRound < (totalRounds - 1) ? true : false);
    const overview = getOverview(gameStateInput, dispatch, this.state, this.props.bankNotificationsState, isHistory);
    const { debitCredit } = gameStateInput.myState;
    const unreadGift = getUnreadGifts(gameStateInput);
    if(overview === null) {
      return "";
    } else {
      return overview.map((parentItem, partsIndex) =>
      <div className={'bank-section overview'} key={partsIndex}>
        <PopupTitle popupId={parentItem.title} tag={'h3'}/>
        {parentItem.items.map((item, index) =>
          <div key={index}
            className={'content-container small' + (this.state.overview[0].items[index].open ? ' show' : '')}
            onClick={this.toggleOpen.bind(this, partsIndex, index, dispatch, item)}>
            <div className='content-container-background'/>
            <p className={'title'}>{item.title}</p>
            {item.keys && (item.keys.some(key => debitCredit[key] && debitCredit[key].confirmed && debitCredit[key].unread) || (item.title === 'Geleend, gekregen of opgenomen' ? unreadGift : false)) ? //bevat het een unread item?
              <div className="notification"><span><p>!</p></span></div>
            :null}
            <span className={'float-right'}>
              <span>{item.points !== 0 ? item.extraInfo || '' : ''}</span>
              <span>{(item.points === undefined || item.points === 0 ? "-" : item.points)}</span>
              <span>{item.pending ? <img alt={__('sim_in_afwachting_status')} src={Pending}/> : ''}</span>
            </span>

            {item.items ?
              <ul className={'overview-list'}>
                {item.items.map((listItem, index) =>
                  <li key={index}>
                    <span className={'image'}><img alt={listItem.title} src={listItem.icon}/></span>
                    <p>{listItem.title}</p>

                    <span className={'float-right-small'}>
                      <span>{listItem.pending ? __('sim_niet_bevestigd_status') : listItem.points}</span>
                      <span>{listItem.pending ? <img alt={__('sim_in_afwachting_status')} src={Pending}/> : <img alt={__('sim_geaccepteerd_status')} src={Approved}/>}</span>
                    </span>
                  </li>
                )}
              </ul>
              : ''}
            </div>
          )}
        </div>
      )
    }
  };

  /**
   * Tegoed wat je krijgt van andere landen
   * @param {Object} gameStateInput
   * @returns {Number} tegoed
   */
  getCreditLand = ({
     states,
     myState: {
       theme,
       roundNumber,
       debitCredit,
     }
   }) => {
    const steps = {
      plus1Rounds: [],
      plus2Rounds: []
    };

    const credit = Object.values(states).reduce((accumilator, round, roundNo) => {
      if(roundNumber >= 4) return accumilator;
      if(roundNo >= (roundNumber - 1) && roundNo > 0 && roundNo <= roundNumber){
        const roundsPassed = roundNumber - roundNo;
        const myRnds = roundNumber === roundNo ? [debitCredit] : Object.values(round)
            .filter((current) => {return current.theme === theme})
            .map((current) => {return current.debitCredit})
            .filter(Boolean);
        const count = Object.keys(myRnds[0]).reduce((accumilatorInner, current) => {
          if(current === 'lenenAanLand' && myRnds[0][current].confirmed === true){
            const object = myRnds[0][current];
            if(roundsPassed === 2) {
              //math floor
              return accumilatorInner + Math.ceil((object.amount / 2) + (object.interest / 2));
            } else if(roundsPassed === 1) {
              //math ceil
              steps.plus1Rounds.push({
                name: 'lenenAanLand',
                otherCountry: object.otherCountry,
                amount: Math.floor((object.amount / 2) + (object.interest / 2))
              });
              return accumilatorInner + Math.floor((object.amount / 2) + (object.interest / 2));
            } else {
              //All moneys
              steps.plus1Rounds.push({
                name: 'lenenAanLand',
                otherCountry: object.otherCountry,
                amount: Math.ceil((object.amount / 2) + (object.interest / 2))
              });
              steps.plus2Rounds.push({
                name: 'lenenAanLand',
                otherCountry: object.otherCountry,
                amount: Math.floor((object.amount / 2) + (object.interest / 2))
              });
              return accumilatorInner + object.amount + object.interest;
            }
          }
          return accumilatorInner;
        }, 0);
        return accumilator + count;
      }
      return accumilator;
    }, 0);
    return {steps, credit};
  };

  /**
   * Tegoed wat je krijgt van de bank
   * @param {Object} gameStateInput
   * @returns {Number} tegoed
   */
  getCreditBank = ({
       states,
       myState: {
         theme,
         roundNumber,
         debitCredit
       }
     }) => {
    const steps = {
      plus1Rounds: [],
      plus2Rounds: []
    };

    let reduceInterestGain = 0;
    const credit = Object.values(states).reduce((accumilator, round, roundNo) => {
      if(roundNo > 0 && roundNo <= roundNumber){
        const roundsPassed = roundNumber - roundNo;
        const myRnds = roundNumber === roundNo ? [debitCredit] : Object.values(round)
            .filter((current) => {return current.theme === theme})
            .map((current) => {return current.debitCredit})
            .filter(Boolean);
        const count = Object.keys(myRnds[0]).reduce((accumilatorInner, current) => {
          if(current === 'stortenSpaargeld' && myRnds[0][current].confirmed === true){
            const object = myRnds[0][current];
            if(roundsPassed === 1) {
              //math ceil
              steps.plus1Rounds.push({
                name: 'sim_rente_op_spaargeld',
                amount: (Math.floor(object.interest))
              });
              return accumilatorInner + Math.floor(object.amount + (roundNumber >= 4 ? 0 : object.interest));
            } else {
              //All moneys
              steps.plus1Rounds.push({
                name: 'sim_rente_op_spaargeld',
                amount: (Math.ceil(object.interest))
              });
              return accumilatorInner + object.amount + (roundNumber >= 4 ? 0 : object.interest);
            }
          } else if(current === 'opnemenSpaargeld' && myRnds[0][current].confirmed === true){
            const object = myRnds[0][current];
            reduceInterestGain = -object.interest;
            return accumilatorInner - object.amount - (roundNumber >= 4 ? 0 : object.interest);
          }
          return accumilatorInner;
        }, 0);
        return accumilator + count;
      }
      return accumilator;
    }, 0);
    const changeindex = steps.plus1Rounds.findIndex(f => f.name === 'sim_rente_op_spaargeld');
    if(changeindex > -1) {
      steps.plus1Rounds[changeindex].amount += reduceInterestGain;
    }
    return {steps, credit};
  };

  /**
   * Tegoed wat je krijgt van de bank
   * @param {Object} gameStateInput
   * @returns {Number} tegoed
   */
  getCreditBankBasic = ({
      states,
      myState: {
        roundNumber,
        debitCredit
      }
    }) => {
    const {gameState} = this.props;
    const saved = gameState.roundData.lastGameState.OneTimeEffect.debitCredit
      .filter(dc => dc.key==='stortenSpaargeld')
      .reduce((acc, dc)=> acc-dc.amount, 0);

    const credit = Object.values(states).reduce((accumilator, round, roundNo) => {
      if(roundNumber - roundNo === 0){
        const count = Object.keys(debitCredit).reduce((accumilatorInner, current) => {
          if(current === 'stortenSpaargeld' && debitCredit[current].confirmed === true){
            const object = debitCredit[current];
            return accumilatorInner + object.amount/* + object.interest*/;
          } else if(current === 'opnemenSpaargeld' && debitCredit[current].confirmed === true){
            const object = debitCredit[current];
            return accumilatorInner - object.amount/* - object.interest*/;
          }
          return accumilatorInner;
        }, 0);
        return accumilator + count + saved;
      }
      return accumilator;
    }, 0);
    return {credit};
  };


  /**
   * Schuld wat je moet betalen aan andere landen
   * @param {Object} gameStateInput
   * @returns {Number} schuld
   */
  getDeptLand = ({
    states,
    myState: {
      theme,
      roundNumber,
      debitCredit,
    }
  }) => {
    const steps = {
      plus1Rounds: [],
      plus2Rounds: []
    };

    const debt = Object.values(states).reduce((accumilator, round, roundNo) => {
      if(roundNumber >= 4) return accumilator;
      if(roundNo >= (roundNumber - 1) && roundNo > 0 && roundNo <= roundNumber){
        const roundsPassed = roundNumber - roundNo;
        const myRnds = roundNumber === roundNo ? [debitCredit] : Object.values(round)
            .filter((current) => {return current.theme === theme})
            .map((current) => {return current.debitCredit})
            .filter(Boolean);
        const count = Object.keys(myRnds[0]).reduce((accumilatorInner, current) => {
          if(current === 'lenenVanLand' && myRnds[0][current].confirmed === true){
            const object = myRnds[0][current];
            if(roundsPassed === 2) {
              //math floor
              return accumilatorInner + Math.ceil((object.amount / 2) + (object.interest / 2));
            } else if(roundsPassed === 1) {
              //math ceil
              steps.plus1Rounds.push({
                name: 'lenenVanLand',
                otherCountry: object.otherCountry,
                amount: Math.floor((object.amount / 2) + (object.interest / 2))
              });
              return accumilatorInner + Math.floor((object.amount / 2) + (object.interest / 2));
            } else {
              //All moneys
              steps.plus1Rounds.push({
                name: 'lenenVanLand',
                otherCountry: object.otherCountry,
                amount: Math.ceil((object.amount / 2) + (object.interest / 2))
              });
              steps.plus2Rounds.push({
                name: 'lenenVanLand',
                otherCountry: object.otherCountry,
                amount: Math.floor((object.amount / 2) + (object.interest / 2))
              });
              return accumilatorInner + object.amount + object.interest;
            }
          }
          return accumilatorInner;
        }, 0);
        return accumilator + count;
      }
      return accumilator;
    }, 0);
    return {steps, debt};
  };

  /**
   * Schuld wat je moet betalen aan de bank
   * @param {Object} gameStateInput
   * @returns {Number} schuld
   */
  getDeptBank = ({
    states,
    myState: {
      theme,
      roundNumber,
      debitCredit,
    }
  }) => {
    const steps = {
      plus1Rounds: [],
      plus2Rounds: []
    };

    const debt = Object.values(states).reduce((accumilator, round, roundNo) => {
      if(roundNumber >= 4) return accumilator;
      if(roundNo >= (roundNumber - 1) && roundNo > 0 && roundNo <= roundNumber){
        const roundsPassed = roundNumber - roundNo;
        const myRnds = roundNumber === roundNo ? [debitCredit] : Object.values(round)
            .filter((current) => {return current.theme === theme})
            .map((current) => {return current.debitCredit})
            .filter(Boolean);
        const count = Object.keys(myRnds[0]).reduce((accumilatorInner, current) => {
          if(current === 'lenenVanBank' && myRnds[0][current].confirmed === true){
            const object = myRnds[0][current];
            if(roundsPassed === 2) {
              //math floor
              return accumilatorInner + Math.ceil((object.amount / 2) + (object.interest / 2));
            } else if(roundsPassed === 1) {
              //math ceil
              steps.plus1Rounds.push({
                name: 'lenenVanBank',
                amount: Math.floor((object.amount / 2) + (object.interest / 2))
              });
              return accumilatorInner + Math.floor((object.amount / 2) + (object.interest / 2));
            } else {
              //All moneys
              steps.plus1Rounds.push({
                name: 'lenenVanBank',
                amount: Math.ceil((object.amount / 2) + (object.interest / 2))
              });
              steps.plus2Rounds.push({
                name: 'lenenVanBank',
                amount: Math.floor((object.amount / 2) + (object.interest / 2))
              });
              return accumilatorInner + object.amount + object.interest;
            }
          }
          return accumilatorInner;
        }, 0);
        return accumilator + count;
      }
      return accumilator;
    }, 0);
    return {steps, debt};
  };

  /**
   * Schuld wat je moet betalen aan de bank
   * @param {Object} gameStateInput
   * @returns {Number} schuld
   */
  getDeptBankBasic = ({
       states,
       myState: {
         roundNumber,
         debitCredit,
       }
     }) => {

    const debt = Object.values(states).reduce((accumilator, round, roundNo) => {
      if(roundNumber - roundNo === 0){
        const count = Object.keys(debitCredit).reduce((accumilatorInner, current) => {
          if(current === 'lenenVanBank' && debitCredit[current].confirmed === true){
            const object = debitCredit[current];
            return accumilatorInner + object.amount + object.interest;
          }
          return accumilatorInner;
        }, 0);
        return accumilator + count;
      }
      return accumilator;
    }, 0);
    return {debt};
  };

  /**
   * Totaal tegoed wat je nog krijgt
   * @param {Object} gameStateInput
   * @returns {Number} tegoed
   */
  getCreditTotal = gameStateInput =>
    Math.floor(this.getCreditLand(gameStateInput).credit + this.getCreditBank(gameStateInput).credit);

  /**
   * Totale schuld wat je nog moet betalen
   * @param {Object} gameStateInput
   * @returns {Number} schuld
   */
  getDeptTotal = gameStateInput =>
    Math.floor(this.getDeptLand(gameStateInput).debt + this.getDeptBank(gameStateInput).debt);

  getConfirmedEntries(input, key, otherKey) {
    const { gameStateInput, gameState } = this.props;
    // Check if debit is confirmed by other group
    const loanFromCountry = input.findIndex(item => item.newDebt.key === key);

    if (loanFromCountry > -1) {
      if (gameStateInput.states[gameState.currentRound]) {
        const isConfirmed = Object.values(gameStateInput.states[gameState.currentRound]).find(state => {
          let groupMatch = state.theme === input[loanFromCountry].newDebt.otherCountry;
          if (groupMatch && state.debitCredit[otherKey]) {
            if (state.debitCredit[otherKey].confirmed &&
                state.debitCredit[otherKey].amount === input[loanFromCountry].newDebt.amount &&
                state.debitCredit[otherKey].interest === input[loanFromCountry].newDebt.interest
              ) {
              return true;
            }
          }
          return false;
        });

        if (!isConfirmed && key === 'lenenVanLand') {
          return input.filter(item => item.newDebt.key !== key);
        }

        if (isConfirmed) {
          if (!this.state[key]) {
            this.setState({[key]: true});
          }
        }
      }
    }
    return input;
  }

  renderPopupTitle() {
    const { desktop } = this.props;

    return (
      <div className={'bank-title-area'}>
        { desktop ? ( <img className={'desktop-title-icon'} src={BankIcon} alt={'Bank Icoon'}/> )
          : null }

        <PopupTitle popupId={desktop ? 'dhgvtsparenenlenen' : 'mhgvtsparenenlenen'} tag={'h3'}/>

        { desktop ? ( <GoBackButton history={this.props.history}/> )
          : null }
      </div>
    )
  }

  renderLowPopupTitle() {
    const { desktop } = this.props;

    return (
      <Fragment>
        <div className={'bank-title-area'}>

          <PopupTitle popupId={desktop ? 'dlgvtsparenenlenen' : 'mlgvtsparenenlenen'} tag={'h3'}/>

          { desktop ? ( <GoBackButton history={this.props.history}/> )
            : null }
        </div>
        { desktop ? ( <img className={'desktop-title-icon low-big'} src={BankIcon} alt={'bank-icon'}/> )
          : null }
      </Fragment>
    )
  }

  renderCurRoundPayback(isDebt, gameState) {
    let introText = '';

    const {gameStateInput} = this.props;

    let plus1Rounds = [];
    let plus2Rounds = [];


    const debitCredit = gameStateInput.myState.debitCredit;
    const debitCreditArr = Object.keys(debitCredit)
      .map(key => ({...debitCredit[key], key}))
      .filter(({confirmed}) => confirmed);

    let nextRoundDeb = debitCreditArr
      .map(r => simulateDebitCreditOutcome({...r, round: gameState.currentRound})).filter(n => n)
      .filter(r => r);

    if (isDebt) {
      introText = 'sim_bank_uitleg_lening_van_andere_landen_aflossen';
      const debtBank = this.getDeptBank(gameStateInput).steps;
      const debtLand = this.getDeptLand(gameStateInput).steps;
      plus1Rounds = [...debtBank.plus1Rounds, ...debtLand.plus1Rounds];
      plus2Rounds = [...debtBank.plus2Rounds, ...debtLand.plus2Rounds];
      this.getConfirmedEntries(
        nextRoundDeb.filter(item => ((item.newDebt.key === 'lenenVanBank') || (item.newDebt.key  === 'lenenVanLand'))),
        'lenenVanLand',
        'lenenAanLand'
      );
    } else {
      introText = 'sim_bank_uitleg_lening_aan_andere_landen_aflossen';
      const creditBank = this.getCreditBank(gameStateInput).steps;
      const creditLand = this.getCreditLand(gameStateInput).steps;
      plus1Rounds = [...creditBank.plus1Rounds, ...creditLand.plus1Rounds];
      plus2Rounds = [...creditBank.plus2Rounds, ...creditLand.plus2Rounds];
      this.getConfirmedEntries(
        nextRoundDeb.filter(item => item.newDebt.key === 'lenenAanLand'),
        'lenenAanLand',
        'lenenVanLand'
      );
    }

    if (plus1Rounds.length) {
      return (
        <div className={'overzicht-schuld-rondes'}>
          <p>{__(introText)}:</p>
          {
            (plus1Rounds.length >= 1 ?
              <div key={'before' + Math.random()} className={'schuld-rondes overview'}>
                <strong>
                  {__('sim_ronde').toLowerCase() + ' ' + (gameState.currentRound + 1)}
                </strong>

                <ul>
                  { plus1Rounds.map((debt) =>
                      <li key={debt.name + Math.random()}>{`${__(debt.name)} ${debt.otherCountry !== undefined ? __(debt.otherCountry) : ''}`}
                        <span>{debt.amount}</span>
                      </li>
                  ) }
                </ul>
              </div>
              :
              null
            )
          }
          {
            (plus2Rounds.length >= 1 ?
                <div key={'after' + Math.random()} className={'schuld-rondes overview'}>
                  <strong>
                    {__('sim_ronde').toLowerCase() + ' ' + (gameState.currentRound + 2)}
                  </strong>

                  <ul>
                    { plus2Rounds.map((debt) =>
                        <li key={debt.name + Math.random()}>{`${__(debt.name)} ${debt.otherCountry !== undefined ? __(debt.otherCountry) : ''}`}
                          <span>{debt.amount}</span>
                        </li>
                    ) }
                  </ul>
                </div>
                :
                null
            )
          }
        </div>
      )
    } else {
      return null;
    }
  }

  renderHoog() {
    const {gameState, gameStateInput, dispatch, desktop} = this.props;
    const { debitCredit } = gameStateInput.myState;
    const tegoed = this.getCreditTotal(gameStateInput);
    const schuld = this.getDeptTotal(gameStateInput);
    const savingsAndLoans = calculateSavingsAndLoans(gameStateInput);
    const globas = calculateBudgetPRO(gameState, gameStateInput, gameStateInput.myState.policyChoices, gameStateInput.myState.ministerieGlobaVerdeling, savingsAndLoans);
    // Snippet to clear DebitCredit

    // if(cleared === 0) {
    //   dispatch(updateMyState(
    //     {
    //       debitCredit:{}
    //     }
    //   ))
    //   cleared = 1;
    // }

    // console.log(debitCredit);
    const content = <div>
      { !desktop ? (
        <Header
          history={this.props.history}
          historic={false}
          buttonType='close'
          viewType='list'
          showTitle={false}
          showBudget={true}/>
      ) : null }


      <div className='container taxes bank'>
        <div className={'values'}>

          {this.renderPopupTitle()}

          <ul>
            <BankSavingDropdown
              class={'dept'}
              title={__('sim_schuld')}
              globas={schuld || '-'}>
              <p>{__('sim_bank_uitleg_totaal_schuld')}</p>
              <ul>
                <li>{__('sim_schulden_aan_landen')} <span>{this.getDeptLand(gameStateInput).debt} {__('sim_miljard_globas')}</span></li>
                <li>{__('sim_schulden_aan_bank')} <span>{this.getDeptBank(gameStateInput).debt} {__('sim_miljard_globas')}</span></li>
                <li className={'divider'}>-------------------------------</li>
                <li><strong>{__('sim_totale_schuld')} <span>{schuld} {__('sim_miljard_globas')}</span></strong></li>
              </ul>
              {/*{this.renderCurRoundPayback(true, gameState)}*/}
            </BankSavingDropdown>

            <BankSavingDropdown
              class={'left'}
              title={__('sim_tegoed')}
              globas={tegoed || '-'}>
              <p>{__('sim_bank_uitleg_totaal_tegoed')}</p>
              <ul>
                <li>{__('sim_tegoed_van_landen')} <span>{this.getCreditLand(gameStateInput).credit} {__('sim_miljard_globas')}</span></li>
                <li>{__('sim_tegoed_bij_bank')} <span>{this.getCreditBank(gameStateInput).credit} {__('sim_miljard_globas')}</span></li>
                <li className={'divider'}>-------------------------------</li>
                <li><strong>{__('sim_totale_tegoed')} <span>{tegoed} {__('sim_miljard_globas')}</span></strong></li>
              </ul>
              {/*{this.renderCurRoundPayback(false, gameState)}*/}
            </BankSavingDropdown>
          </ul>
        </div>

        <div className={'collect-spend-globas-overview'}>
          <div className={'bank-section'}>
            <h3>{__("sim_wij_hebben_globas_nodig")}</h3>
            <DebitCreditDialog
              id={desktop ? 'dhgvtlenenland' : 'mhgvtlenenland'}
              title={__("sim_lenen_van_land")}
              sliderTitle={`${__("sim_lenen_van_land")}`}
              sliderTitle_confirmed={`${__("sim_geleend_van_land")}`}
              sliderTitleAppend={`(max. ${(20 + (30 * (gameState.currentRound - 1)))} ${__('sim_miljard')})`}
              max={(20 + (30 * (gameState.currentRound - 1)))}
              icon={LoanLand}
              value={debitCredit.lenenVanLandNotConfirmed || {}}
              onChange={(value) => dispatch(updateMyState(
                {
                  debitCredit:{...debitCredit, lenenVanLandNotConfirmed: value}
                }
              ))}
              fromCountry
              confirmed={(debitCredit.lenenVanLandNotConfirmed || {}).confirmed}
              disableInFinalStep={true}
              disableCancel={(debitCredit.lenenVanLand || {}).confirmed}
              allowInput={this.props.user.role === 'groupleader'}
            />

            <DebitCreditDialog
              id={desktop ? 'dhgvtlenenbank' : 'mhgvtlenenbank'}
              title={__("sim_lenen_van_bank")}
              max={80 - (30 * (gameState.currentRound - 1))}
              sliderTitleAppend={`(max. ${80 - (30 * (gameState.currentRound - 1))} ${__('sim_miljard')})`}
              icon={LoanBank}
              value={debitCredit.lenenVanBank || {}}
              onChange={(value) => dispatch(updateMyState(
                {
                  debitCredit:{...debitCredit, lenenVanBank: value}
                }
              ))
              }
              creditRate={.2}
              renteTitle={`${__('sim_te_betalen_rente')} (${.2 * 100}%)`}
              allowInput={this.props.user.role === 'groupleader'}
              disableInFinalStep={true}
              disableCancel={(debitCredit.lenenVanBank || {}).confirmed}
              roundUp={true}
            />

            <DebitCreditDialog
              id={desktop ? 'dhgvtopnemenspaargeld' : 'mhgvtopnemenspaargeld'}
              title={__("sim_opnemen_spaargeld")}
              max={getSavedGlobas(gameState, debitCredit)}
              icon={Savings}
              value={debitCredit.opnemenSpaargeld || {}}
              remainingTitle={__('sim_nieuw_spaargeld')}
              currentValue={getSavedGlobas(gameState, debitCredit)}
              currentValueTitle={__('sim_huidig_spaargeld')}
              sliderTitle={__('sim_opname_spaargeld')}
              allowInput={this.props.user.role === 'groupleader'}
              disableCancel={(debitCredit.opnemenSpaargeld || {}).confirmed}
              onChange={(value) => dispatch(updateMyState(
                {
                  debitCredit:{...debitCredit, opnemenSpaargeld: value}
                }
              ))
              }
              noInterest={true}
              creditRate={.1}
              savedThisRound={debitCredit.stortenSpaargeld || {}}
            />
          </div>

          <div className={'bank-section'}>
            <h3>{__('sim_wij_hebben_globas_over')}</h3>

            <DebitCreditDialog
              id={desktop ? 'dhgvtuitlenen' : 'mhgvtuitlenen'}
              title={__("sim_lenen_aan_land")}
              sliderTitle={`${__("sim_lenen_aan_land")}`}
              sliderTitle_confirmed={`${__("sim_uitgeleend_aan_land")}`}
              sliderTitleAppend={`(max. ${(20 + (30 * (gameState.currentRound - 1)) < globas ? (20 + (30 * (gameState.currentRound - 1))) : globas)} ${__('sim_miljard')})`}
              icon={LoanToLand}
              max={(20 + (30 * (gameState.currentRound - 1)) < globas ? (20 + (30 * (gameState.currentRound - 1))) : globas)}
              value={debitCredit.lenenAanLandNotConfirmed || {}}
              allowInput={this.props.user.role === 'groupleader' && !this.state.lenenAanLand}
              onChange={(value) => dispatch(updateMyState(
                {
                  debitCredit:{...debitCredit, lenenAanLandNotConfirmed: value}
                }
              ))}
              toCountry={__('sim_uitgeleend_aan_land')}
              confirmed={(debitCredit.lenenAanLand || {}).confirmed}
              disableCancel={(debitCredit.lenenAanLand || {}).confirmed}
              disableInFinalStep={true}
            />

            <DebitCreditDialog
              id={desktop ? 'dhgvtschenken' : 'mhgvtschenken'}
              title={__("sim_schenken_aan_land")}
              max={20 < globas ? 20 : globas}
              icon={Gift}
              sliderTitle={`${__('sim_schenking')}`}
              sliderTitleAppend={`(max. ${(20 < globas ? 20 : globas)} ${__('sim_miljard')})`}
              value={debitCredit.schenkAanLand || {}}
              allowInput={this.props.user.role === 'groupleader'}
              onChange={(value) => dispatch(updateMyState(
                {
                  debitCredit:{...debitCredit, schenkAanLand: value}
                }
              ))}
              toCountry={__('sim_schenk_aan_land')}
              disableCancel={(debitCredit.schenkAanLand || {}).confirmed}
              noInterest
            />

            <DebitCreditDialog
              id={desktop ? 'dhgvtsparenbank' : 'mhgvtsparenbank'}
              title={__('sim_sparen_bij_bank')}
              max={30 < globas ? 30 : (globas < 0 ? 0 : globas)}
              icon={SavingsBank}
              value={debitCredit.stortenSpaargeld || {}}
              renteValue={getSavingsInterest(gameState, debitCredit, getSavedGlobas(gameState, debitCredit), .1)}
              accumulativeTitle={__('sim_nieuw_spaargeld')}
              currentValue={getSavedGlobas(gameState, debitCredit)}
              currentValueTitle={__('sim_huidig_spaargeld')}
              allowInput={this.props.user.role === 'groupleader'}
              disableCancel={(debitCredit.stortenSpaargeld || {}).confirmed}
              sliderTitle={`${__('sim_spaarbedrag')}`}
              sliderTitleAppend={`(max. 30 ${__('sim_miljard')})`}
              onChange={(value) => dispatch(updateMyState(
                {
                  debitCredit:{...debitCredit, stortenSpaargeld: value}
                }
              ))
              }
              creditRate={.1}
              renteTitle={`${__('sim_te_ontvangen_rente')} (${.1 * 100}%)`}
            />
          </div>
        </div>

        {this.printOverview(gameStateInput, dispatch)}
      </div>
    </div>;


    if (!desktop) {
      return (
        <div className={'darkBckg'}>
          {content}
          <NextStep/>
        </div>
      );
    } else {
      return (
        <div className={'darkBckg'}>
          <Scrollbar className="custom-height" noScrollX style={ {width: '100%', height: '100%', minHeight: 300} } >
            {content}
          </Scrollbar>
          <NextStep/>
        </div>
      );
    }
  }

  renderLaag() {
    const {debitCredit} = this.props.gameStateInput.myState;
    const {gameState, dispatch, gameStateInput, policyChoice, desktop} = this.props;

    const savingsAndLoans = calculateSavingsAndLoans(gameStateInput);
    const globas = calculateBudgetBASIC(gameState, gameStateInput.myState.policyChoices, gameStateInput.myState.ministerieGlobaVerdeling, savingsAndLoans, policyChoice);
    const content = (
      <div className={'darkBckg'} style={{height: "auto"}}>
        { !desktop ? (
          <Header
            history={this.props.history}
            historic={false}
            buttonType='close'
            viewType='list'
            showTitle={false}
            showBudget={true}/>
        ) : null }

        <div className='container taxes bank laag'>
          <div className={'values'}>
            { this.renderLowPopupTitle() }

            <ul>
              <BankSavingDropdown
                class={'dept'}
                title={__('sim_schuld')}
                onlyThumbTitle={true}
                globas={this.getDeptBankBasic(gameStateInput).debt}>
                <span dangerouslySetInnerHTML={{__html: getContent('dlgvtschuld', this.props.gameState.language)}}></span>
              </BankSavingDropdown>
              <BankSavingDropdown
                class={'left'}
                title={__('sim_spaartegoed')}
                onlyThumbTitle={true}
                globas={this.getCreditBankBasic(gameStateInput).credit}>
                <span dangerouslySetInnerHTML={{__html: getContent('dlgvtspaartegoed', this.props.gameState.language)}}></span>
              </BankSavingDropdown>
            </ul>
          </div>
          <div className={'bank-section'}>
            <DebitCreditDialog
              id={desktop ? 'dlgvtlenenbank' : 'mlgvtlenenbank'}
              title={__('lenenVanBank')}
              max={15}
              icon={LoanBankLow}
              value={debitCredit.lenenVanBank || {}}
              sliderTitle={__('sim_lening')}
              renteTitle={__('sim_basic_rente_die_je_betaald')}
              allowInput={this.props.user.role === 'groupleader'}
              disableCancel={(debitCredit.lenenVanBank || {}).confirmed}
              disableInFinalStep={true}
              onChange={(value) => dispatch(updateMyState(
                {
                  debitCredit:{...debitCredit, lenenVanBank: value}
                }
              ))
              }
              creditRate={.2}
              roundUp={true}
            />
            <DebitCreditDialog
              id={desktop ? 'dlgvtsparenbank' : 'mlgvtsparenbank'}
              title={__('stortenSpaargeld')}
              max={15 < globas ? 15 : (globas < 0 ? 0 : globas)}
              icon={SavingsBank}
              value={debitCredit.stortenSpaargeld || {}}
              currentValue={getSavedGlobas(gameState, debitCredit)}
              currentValueTitle={__('sim_huidig_spaargeld')}
              renteTitle={__('sim_basic_te_ontvangen_rente')}
              renteValue={getSavingsInterest(gameState, debitCredit, getSavedGlobas(gameState, debitCredit), .2)}
              accumulativeTitle={__((!(debitCredit.stortenSpaargeld || {}).confirmed ? 'sim_basic_nieuw_spaargeld' : 'sim_basic_nieuw_spaartegoed'))}
              sliderTitle={__((!(debitCredit.stortenSpaargeld || {}).confirmed ? 'sim_welk_bedrag_sparen' : 'sim_welk_bedrag_gespaard'))}
              allowInput={this.props.user.role === 'groupleader'}
              disableCancel={(debitCredit.stortenSpaargeld || {}).confirmed}
              onChange={(value) => dispatch(updateMyState(
                {
                  debitCredit:{...debitCredit, stortenSpaargeld: value}
                }
              ))
              }
              creditRate={.2}
            />

            <DebitCreditDialog
              id={desktop ? 'dlgvtopnemenspaargeld' : 'mlgvtopnemenspaargeld'}
              title={__('sim_opnemen_spaargeld')}
              max={getSavedGlobas(gameState, debitCredit)}
              currentValue={getSavedGlobas(gameState, debitCredit)}
              icon={Savings}
              value={debitCredit.opnemenSpaargeld || {}}
              remainingTitle={__((!(debitCredit.opnemenSpaargeld || {}).confirmed ? 'sim_basic_nieuw_spaargeld' : 'sim_basic_nieuw_spaartegoed'))}
              sliderTitle={__((!(debitCredit.opnemenSpaargeld || {}).confirmed ? 'sim_basic_opname_spaargeld' : 'sim_basic_opgenomen_spaargeld'))}
              allowInput={this.props.user.role === 'groupleader'}
              disableCancel={(debitCredit.opnemenSpaargeld || {}).confirmed}
              renteValue={getSavingsInterest(gameState, debitCredit, getSavedGlobas(gameState, debitCredit), .2) - getSavingsInterest(gameState, debitCredit, getSavedGlobas(gameState, debitCredit), .2, true)}
              onChange={(value) => dispatch(updateMyState(
                {
                  debitCredit:{...debitCredit, opnemenSpaargeld: value}
                }
              ))
              }
              savedThisRound={debitCredit.stortenSpaargeld || {}}
              noInterest={true}
              creditRate={.2}
            />

          </div>
        </div>
      </div>
    );

    if (!desktop) {
      return (
        <div className={'darkBckg'}>
          {content}
          <NextStep/>
        </div>
      );
    } else {
      return (
        <div className={'darkBckg'}>
          <NextStep/>
          <Scrollbar className="custom-height" noScrollX style={ {width: '100%', height: '100%', minHeight: 300} } >
            {content}
          </Scrollbar>
        </div>
      );
    }
  }
}

export default connect(state => ({
  gameState: state.gameState,
  gameStateInput: state.gameStateInput,
  project: state.project,
  policyChoice: state.policyChoice,
  user: state.user,
  feedback: state.feedback,
}))(Bank);



// WEBPACK FOOTER //
// ./src/components/routes/Bank.js